<template>
  <v-main>
    <div id="loginBackground"></div>

    <v-app-bar
      flat
      height="110"
      color="transparent"
      style="position: absolute; top: 0; left: 0; width: 100%;"
    >
      <v-toolbar-title
        style="width: 130px; cursor: pointer"
        class="ml-0 px-4"
      >
        <div>
          <v-img
            src="@/assets/branding/gcg_logo.png"
            contain
            height="30"
          />
        </div>
      </v-toolbar-title>

      <v-spacer />

      <div class="hidden-sm-and-down px-4">
        <v-img
          src="@/assets/branding/gcg_slogan.png"
          contain
          width="160"
        />
      </div>
    </v-app-bar>

    <v-container
      class="pa-0 fill-height"
      fluid
    >
      <div
        class="ma-0 d-flex flex-column flex-nowrap justify-space-between align-center"
        style="width: 100%; height: 100%;"
      >
        <!-- Justify Align bar -->
        <div style="width: 100%; height: 100px;"></div>

        <!-- Login form -->
        <div class="pa-3 mx-auto">
          <v-card
            id="loginCard"
            class="elevation-20 mx-auto"
            max-width="400"
          >
            <v-toolbar
              color="primary"
              dark
              flat
              max-width="400"
            >
              <v-toolbar-title>
                Dashboard Login
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pb-0">
              <v-form
                ref="loginForm"
                v-model="validate"
              >
                <v-text-field
                  v-model="form.email"
                  label="Email"
                  name="login"
                  prepend-icon="mdi-account"
                  type="text"
                  :rules="[rules.required, rules.email]"
                  @keyup.enter="clickLogin()"
                />

                <v-text-field
                  id="password"
                  v-model="form.password"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  label="Password"
                  name="password"
                  prepend-icon="mdi-lock"
                  :type="show ? 'text' : 'password'"
                  :rules="[rules.required]"
                  @keyup.enter="clickLogin()"
                  @click:append="show = !show"
                />
              </v-form>
            </v-card-text>
            <v-card-actions class="pb-3">
              <v-row>
                <v-col cols="12">
                  <v-btn
                    class="mt-n1 mb-n3"
                    dark
                    color="#1a97f2"
                    block
                    :loading="loading"
                    @click="clickLogin()"
                  >
                    Login
                  </v-btn>
                </v-col>

                <v-col
                  cols="12"
                  class="py-0 mb-1"
                >
                  <v-btn
                    color="info"
                    text
                    block
                    class="mt-1 text-capitalize font-weight-medium text-decoration-underline"
                    @click="clickForgot"
                  >
                    Forgot my password
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
            <div
              class="pa-2 text-center body-2"
              style="background: white; width: 100%; border-top: 1px solid #d1d1d1;"
            >
              For support and inquiries contact
              <a href="mailto:Support@GlobalCoachGroup.com">
                Support@GlobalCoachGroup.com
              </a>
            </div>
          </v-card>
        </div>

        <!-- Footer -->
        <div
          class="py-7 px-8 mb-0 body-2"
          style="
            width: 100%;
            color: white;
            background: rgba(255, 255, 255, 0.1);
            text-align: center;
            z-index: 200;"
        >
          The platform is owned and operated by Global Coach Group. Copyright 2021
        </div>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      validate: true,
      rules: {
        required: (value) => !!value || 'Required.',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid e-mail.';
        },
      },
      loading: false,
      show: false,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.account.user,
    }),

    ...mapGetters('account', {
      isAuthenticate: 'isAuthenticate',
    }),
  },

  async created() {
    this.$vuetify.theme.dark = false;

    await this.getCurrentUser();

    if (this.isAuthenticate) {
      this.redirectToDashboard();
    }

    if (!process.env.VUE_APP_ENV || process.env.VUE_APP_ENV === 'local') {
      this.form.email = 'demo1@sccoaching.com';
      this.form.password = '12345678';
    }
  },

  methods: {
    ...mapActions('account', [
      'login',
      'getCurrentUser',
      'logout',
    ]),

    clickForgot() {
      this.$router.push({ name: 'forgotPassword' }).catch(() => {});
    },

    async clickLogin() {
      if (this.$refs.loginForm.validate()) {
        try {
          this.loading = true;
          await this.login(this.form);

          this.redirectToDashboard(true);
        } catch (err) {
          if (err.msg) {
            this.$toast.error(err.msg);
          }
        } finally {
          this.loading = false;
        }
      } else {
        this.$toast.error('Please check input fields.');
      }
    },

    redirectToDashboard(onLogin) {
      const platformQuery = this.$route.query['platform-query'];
      if (this.$route.query.redirect_to) {
        window.location.href = `${this.$route.query.redirect_to}${platformQuery ? `?${platformQuery}` : ''}`;
      } else if (this.user.is_staff) {
        window.location.href = process.env.VUE_APP_MAM_CLIENT;
      } else {
        let service;
        if (this.$route.query.redirect
          && this.user.services.some((el) => el.service_id === this.$route.query.redirect)) {
          service = this.$route.query.redirect;
        } else if (this.user.services.length > 0) {
          service = this.user.services[0].service_id;
        }

        let url = '';
        switch (service) {
          case 'gcg_coach':
            url = process.env.VUE_APP_COACH_CLIENT;
            break;
          case 'gla360':
            url = process.env.VUE_APP_GLA_CLIENT;
            break;
          case 'gcg_platform':
            url = process.env.VUE_APP_GCG_PLATFORM_CLIENT;
            break;
          case 'ing_gcg_platform':
            url = process.env.VUE_APP_ING_PLATFORM_CLIENT;
            break;
          case 'coach_tools':
            url = process.env.VUE_APP_COACH_TOOLS_CLIENT;
            break;
          default:
            if (onLogin) {
              this.$router.push({ name: 'settings' });
            }
        }
        window.location.href = `${url}${platformQuery ? `?${platformQuery}` : ''}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #loginBackground {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: radial-gradient(circle at bottom right, #010f27, #003865);
    background-size: cover;
    background-attachment: fixed;
  }

  #loginCard {
    background: transparent;
    .v-card__text {
      background: white;
    }
    .v-card__actions {
      margin-top: -1px;
      background: white;
    }
  }
</style>
